import * as React from "react"
import { Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const Card = ({ postData, linkTo }) => {
  const postImage = getImage(postData.image)

  return (
    <Link to={linkTo} className="card">
      <GatsbyImage image={postImage} alt={postData.title + " thumbnail"} />
      <h2 className="card-title">{postData.title}</h2>
    </Link>
  )
}

export default Card
